import router from './router'
import { isMobile } from "./utils/pcormobile";
import routerH5 from "@/router/routerH5";

function isH5ath(str) {
  var bool = false
  for (let i = 0; i < routerH5.length; i++) {
    const ele = routerH5[i];
    if (ele.path == str) {
      bool = true
      break
    }
  }
  return bool
}

router.beforeEach((to, from, next) => {
  // next()
  //暂时保留，后期做h5端使用

  if (isMobile() && !isH5ath(to.path)) {
    next('/')
  } else {
    if (isMobile()) {
      next();
      // return
    } else {
      next()
    }

  }
})


// WEBPACK FOOTER //
// ./src/permission.js